<template>
    <MainLayout>
        <div class="pagetitle">
            <h1>Mi Perfil</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/">
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Perfil</li>
                </ol>
            </nav>
        </div>

        <section class="section dashboard">

            <div class="card">

                <div class="card-header py-3">

                    <div class="row">

                        <h3 class="m-0 font-weight-bold text-primary col-md-11">Actualizar perfil</h3>

                    </div>

                </div>

                <div class="card-body mt-2">
                    <Atom1Loader v-if="loading" />
                    

                    <form class="row g-3" v-else>

                        <div class="col-md-12">

                            <div class="row">

                                <div class="col-md-12">
                                    <div class="form-floating">
                                        <input v-model="email" class="form-control" placeholder="Email" readonly>
                                        <label>Email</label>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-floating mt-2">
                                        <input v-model="firstName" class="form-control" placeholder="Nombres..."
                                            :class="{ 'is-invalid': v$.firstName.$error }">
                                        <label>Nombres</label>
                                        <div v-if="v$.firstName.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.firstName) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-floating mt-2">
                                        <input v-model="lastName" class="form-control" placeholder="Apellidos...">
                                        <label>Apellidos</label>
                                        <div v-if="v$.lastName.$error" class="invalid-feedback animated fadeInDown"
                                            style="display: block;">
                                            {{ validationMessage(v$.lastName) }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-floating mt-2">
                                        <input v-model="phone" class="form-control" placeholder="Teléfono..." type="number">
                                        <label>Teléfono</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-floating mt-2">
                                        <input v-model="document" class="form-control" placeholder="Documento...">
                                        <label>Documento</label>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="text-center">
                            <button class="btn btn-primary" @click.prevent="updateCurrentUser">Actualizar</button>
                                                         
                            <router-link :to="{ name: 'ResetPassword', params: { type: 'Reset' } }" class="btn btn-warning ml-2">
                                <span>Cambiar contraseña</span>
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </MainLayout>
</template>

<script>
import useValidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';

import MainLayout from '@/layouts/MainLayout';
import toastMixin from '@/mixins/toastMixin';
import accountMixin from '@/mixins/accountMixin';
import validatorMixin from '@/mixins/validatorMixin';
import axios from "axios";
import { checkCatch } from "@/utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {

    mixins: [toastMixin, accountMixin, validatorMixin],

    name: 'Profile',

    components: {
        MainLayout,
        Atom1Loader,
    },

    data() {

        return {

            v$: useValidate({ $stopPropagation: true }),

            loading: false,

            email: '',
            firstName: '',
            lastName: '',
            document: '',
            phone: 0,
        };
    },

    validations() {

        return {

            firstName: { required, minLength: minLength(3) },
            lastName: { required, minLength: minLength(3) },
            phone: { required },
            document: { required },
        };
    },

    mounted() {

        this.loadUser();
    },

    methods: {

        loadUser() {

            this.loading = true;

            this.email = this.accountUser.email
            this.firstName = this.accountUser.first_name
            this.lastName = this.accountUser.last_name
            this.document = this.accountUser.first_name
            this.phone = this.accountUser.phone
            this.document = this.accountUser.document

            this.loading = false;
        },

        async updateCurrentUser() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            const data = {
                
                first_name: this.firstName,
                last_name: this.lastName,
                extra_data: {
                    phone: this.phone,
                    document: this.document
                }
            };

            const headers = {

                'Authorization': `Bearer ${this.accountUser.token}`
            };

            await axios.put(`${this.$env.API_BASE_URL}profile-update/`, data, { headers })
                .then(() => {

                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Perfil actualizado con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    checkCatch(error);
                });

        },
    },
};
</script>